export default '/build/f48a4a16.svg'